const IMAGE_UPLOAD_SUCCESS = 'app/imageUpload/IMAGE_UPLOAD_SUCCESS'
const IMAGE_UPLOAD_ERROR = 'app/imageUpload/IMAGE_UPLOAD_ERROR'

export {
  IMAGE_UPLOAD_SUCCESS,
  IMAGE_UPLOAD_ERROR
}
